import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-seafood',
  templateUrl: './icon-seafood.component.html',
  styleUrls: ['./icon-seafood.component.scss']
})
export class IconSeafoodComponent implements OnInit {

  @Input() cssClass = 'icon--18';
  
  constructor() { }

  ngOnInit() {
  }

}
